import React from 'react';
import PropTypes from 'prop-types';
// import outdoorLogo from '../../img/outdoor-logo';
import SafeHTML from './SafeHTML';
import ImageBlock from './ImageBlock';
import customPropTypes from '../utils/customPropTypes';
import style from 'scss/components/Footer';
import moment from 'moment';
import GenericNavListFooter from './MainNavigation/GenericNavListFooter';
import logo from '../../img/hunterlab-white.png';
import LangLogo from '../../img/globe.svg';
import { Button, Input } from 'semantic-ui-react';
// import 'semantic-ui-css/semantic.min.css'

export default class Footer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { 
      langBlog: false,
      isDocsPage : false,
     };
  }

  static propTypes = {
    heading: PropTypes.string,
    contact_phone: PropTypes.string,
    contact_address: PropTypes.string,
    contact_address_spanish: PropTypes.string,
    instagram_link: PropTypes.string,
    facebook_link: PropTypes.string,
    linkedin_link: PropTypes.string,
    twitter_link: PropTypes.string,
    privacyPolicy: PropTypes.string,
    termsOfUse: PropTypes.string,
    certifications: PropTypes.string,
    sitemap: PropTypes.string,
    privacyPolicySpanish: PropTypes.string,
    termsOfUseSpanish: PropTypes.string,
    certificationsSpanish: PropTypes.string,
    sitemapSpanish: PropTypes.string,
    privacyPolicyUKEnglish: PropTypes.string,
    termsOfUseUKEnglish: PropTypes.string,
    certificationsUKEnglish: PropTypes.string,
    sitemapUKEnglish: PropTypes.string,
  }

  static defaultProps = {
    address: '',
    city: '',
    state: '',
    zip: '',
  }
  year = moment().format('YYYY')
  getImageProp = () => {
    let img = {};
    img.url = logo;
    img.title = this.props.heading;
    return img;
  }


  getLangImageProp = () => {
    let img = {};
    img.url = LangLogo;
    return img;
  }

  redirectToContactPage = () => {
    var regexen = /\/en\//;
    var regexenuk = /\/en-uk\//;
    var regexblog = /\/blog\//;
    var regexes = /\/es\//;

    var url = window.location.pathname

    if(regexenuk.test(url)){
      window.location.href = "/en-uk/contact/#newContactFormId";
      return;
    }

    if(regexen.test(url)){
      window.location.href = "/en/contact/#newContactFormId";
      return;
    }

    if(regexblog.test(url)){
      window.location.href = "/en/contact/#newContactFormId";
      return;
    }

    if(regexes.test(url)){
      window.location.href = "/es/contact/#newContactFormId";
      return;
    }

  }

  componentDidMount() {
    let docsSlug = window.location.pathname.split("/").filter(Boolean).at(-1)
    if (docsSlug == "documents"){
      this.setState({isDocsPage : true})
    }
    let bstr = window.location.href;
    if(bstr.includes("/blog")) {
      this.setState({ langBlog: true }, () => {
      });
    }
  }

  togglelangMenu(lang){
    let str = window.location.href;
    if(str.includes('/es/')){
      if(lang == 'English'){
        location.href = window.location.origin+window.location.pathname.replace("/es/",'/en/');
      }
      else if(lang == 'UK English'){
        location.href = window.location.origin+window.location.pathname.replace("/es/","/en-uk/");
      }
    }
    if(str.includes('/en/')){
      if(lang == 'Español'){
        location.href = window.location.origin+window.location.pathname.replace("/en/",'/es/');
      }
      else if(lang == 'UK English'){
        location.href = window.location.origin+window.location.pathname.replace("/en/","/en-uk/");
      }
    }
    if(str.includes('/en-uk/')){
      if(lang == 'Español'){
        location.href = window.location.origin+window.location.pathname.replace("/en-uk/",'/es/');
      }
      else if(lang == 'English'){
        location.href = window.location.origin+window.location.pathname.replace("/en-uk/","/en/");
      }
    }
  }

  togglelangMenu_China() {
    let str = window.location.href;
    if(str.includes('/es/')){
    location.href = "https://www.hunterlabcolor.cn/"+window.location.pathname.replace("/es/",'');
    }
    else{
      location.href = "https://www.hunterlabcolor.cn/"+window.location.pathname.replace("/en/",'');
    }
  }
  
  render() {
    let str = window.location.href;
    let privacy_Policy = str.includes("/es/") ?this.props.privacyPolicySpanish:str.includes("/en-uk/") ?this.props.privacyPolicyUKEnglish:this.props.privacyPolicy;
    let terms_Of_Use = str.includes("/es/") ?this.props.termsOfUseSpanish:str.includes("/en-uk/") ?this.props.termsOfUseUKEnglish:this.props.termsOfUse;
    let certifications_val = str.includes("/es/") ?this.props.certificationsSpanish:str.includes("/en-uk/") ?this.props.certificationsUKEnglish:this.props.certifications;
    let site_map = str.includes("/es/") ?this.props.sitemapSpanish:str.includes("/en-uk/") ?this.props.sitemapUKEnglish:this.props.sitemap;
    let contact_page_url = str.includes("/es/") ?this.props.contact_page_es_url:str.includes("/en-uk/") ?this.props.contact_page_uk_url:this.props.contact_page_en_url;
    let content = str.includes("/es/") ? 'Póndase en contacto':'Get in touch';

    let certifications_name,termsOfUse_name,privacy_Policy_name,contact_name,support_name,contact_add,home_url,home_Name1,home_Name2,country_name;

    if(str.includes("/es/")){
      certifications_name = 'Certificaciones';
      termsOfUse_name = 'Términos de uso';
      privacy_Policy_name = 'Política de privacidad';
      contact_name = 'Contacto';
      support_name = 'Asistencia';
      contact_add = this.props.contact_address_spanish;
      home_url = window.location.origin +'/es/';
      country_name = 'USA';
      home_Name1 = 'English';
      home_Name2 = 'UK English';
    }

    if(str.includes("/en-uk/")){
      certifications_name = 'Certifications';
      termsOfUse_name = 'Purchase Order Terms and Conditions';
      privacy_Policy_name = 'Privacy Policy';
      contact_name = 'Contact';
      support_name = 'Support';
      contact_add = this.props.contact_address;
      home_url = window.location.origin +'/en-uk/';
      home_Name1 = 'English';
      home_Name2 = 'Español';
    }
    
    if(str.includes("/en/")){
      certifications_name = 'Certifications';
      termsOfUse_name = 'Purchase Order Terms and Conditions';
      privacy_Policy_name = 'Privacy Policy';
      contact_name = 'Contact';
      support_name = 'Support';
      contact_add = this.props.contact_address;
      home_url = window.location.origin +'/en/';
      country_name = 'Latin America';
      home_Name1 = 'Español';
      home_Name2 = 'UK English';
    }
    
    if(str.includes("/blog/")){
      certifications_name = 'Certifications';
      termsOfUse_name = 'Purchase Order Terms and Conditions';
      privacy_Policy_name = 'Privacy Policy';
      contact_name = 'Contact';
      support_name = 'Support';
      contact_add = this.props.contact_address;
      home_url = window.location.origin +'/en/';
      country_name = 'Latin America';
    }

    return (
     !this.state.isDocsPage &&  <div>
        {/* {(window.location.pathname.includes("/contact") == false) && (
        <div className="card-container">
          <div className="ctaCardForm" onClick={this.redirectToContactPage}>
            <div className="ctaCardForm-content" onClick={this.redirectToContactPage}>
              <h2 className="ctaCardForm-title" onClick={this.redirectToContactPage}>CONTACT US</h2>
              <div style={{ padding: '0px 12px 10px 12px' }}>
                <input type="text" placeholder="First Name *" onClick={this.redirectToContactPage} readOnly /><br />
                <input type="text" placeholder="Last Name *" onClick={this.redirectToContactPage} readOnly /><br />
                <button type="button" className="ctaCardForm-button" onClick={this.redirectToContactPage} readOnly>
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      )} */}
      <footer className="footer">
        <section className="footer-top">
          <div style={{'maxWidth':'none'}} className="container">
            <div className="row">
              <div className="col footer-contact-info">
                <div className="hunterlab-info">
                  <h2 >
                  <ImageBlock image={this.getImageProp()} title="HunterLab Logo" imgClassName="object-embed" addWrapper={false} ></ImageBlock>
                  </h2>
                  
                  <h4 className="footer-num"><a href={"tel:" + this.props.contact_phone}><i className="icon-caret"></i> {this.props.contact_phone}</a></h4>
                  <div className="footer-addr">
                    <SafeHTML>{contact_add}</SafeHTML>
                  </div>

                  {/* <span className="" style={{color:"white", fontWeight:'bold', fontSize:'17px', marginTop:'15px', lineHeight:'1.2',paddingRight:'30px'}}>Subscribe To Our Newsletter</span>
                  <input
                        style={{ marginTop:'15px', lineHeight:'1.2' }}
                        className="newsletter_input"
                        placeholder="Enter Your Email"
                    />
                    <button
                        style={{ backgroundColor: "#5589BF", color: "white", paddingLeft:'25px',paddingRight:'25px', marginTop:'15px', marginBottom:'25px'}}
                        className="newsletter_input_box_button"
                    >
                      Subscribe
                    </button> */}

                  <aside className="social-links">
                  <h4 className="social-links-title">{content}</h4>
                    {/* <a href={this.props.instagram_link} target="_blank" className="icon icon-instagram" /> */}
                    <a href={this.props.linkedin_link} target="_blank" className="icon icon-linkedin" />
                    <a href={this.props.facebook_link} target="_blank" className="icon icon-facebook" />
                    <a href={this.props.twitter_link} target="_blank" className="icon fa-brands fa-x-twitter" ></a>
                  </aside>
                </div>
              </div>
              <div className="col footer-top-menu">
                <GenericNavListFooter
                footer="footer-link"
                  items={this.props.mainMenuItems} showDesc={false}>
                </GenericNavListFooter>
              </div>
            </div>
            {!this.state.langBlog &&
              <div className='lang-footer'>
                  <ImageBlock image={this.getLangImageProp()} addWrapper={false}></ImageBlock>
                  <a href="#" onClick={() => this.togglelangMenu_China()}className='lang-link'>简体中文</a>
                  <a href='https://www.hunterlab.de' className='lang-link'>Deutsch</a>
                  <a href="#" onClick={() => this.togglelangMenu(home_Name1)} className='lang-link'><span>{home_Name1}</span></a>
                  <a href="#" onClick={() => this.togglelangMenu(home_Name2)} className='lang-link'><span>{home_Name2}</span></a>
              </div>
            }
          </div>
        </section>

        <section className="footer-bottom">
          <div className="container">
            <div className="row">
              <div className="col">
                <span>&copy; {this.year} Hunter Associates Laboratory, Inc.</span>
              </div>
              <div className="col">
                
                <ul className="menu">
                  <li><a href={certifications_val}>{certifications_name}</a></li>
                  <li><a href={terms_Of_Use}>{termsOfUse_name}</a></li>
                  <li><a href={privacy_Policy}>{privacy_Policy_name}</a></li>
                  <li><a href={site_map}>Sitemap</a></li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </footer>
    </div>
    )
  }

}
